import React from 'react';
import { useSelector } from 'react-redux';
import { DisposableAlert } from './shared/DisposableAlert';
import { clearAlertText } from '../actions';
import { StatusBarAlert } from './statusBar/StatusBarAlert';
import { useDispatch } from 'react-redux';
import './InitializationError.scss';

export const InitializationError = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.app.isLoading);
  const alertText = useSelector((state) => state.app.alertText);
  const emailDelegateError = useSelector((state) => state.mail.delegateError);
  return (
    <div className={'initializationError-container'}>
      <div className='app-notifications'>
        { alertText &&
        <DisposableAlert child={<StatusBarAlert />}
          disposeFunction={() => {
            dispatch(clearAlertText());
          }}
          timeout={3000}
        />}
      </div>
      { !isLoading ?
        emailDelegateError ?
          <div className='initializationError-content'>
            <p className='initializationError-heading'>The Mailbox owner is not an Email User.</p>
            <p className='initializationError-paragraph'>Make sure they log into the add-in, or contact your Admin to resolve.</p>
          </div> :
          <div className='initializationError-content'>
            <p className='initializationError-heading'>Something went wrong.</p>
            <p className='initializationError-paragraph'>Close the add in and reopen or contact your Admin for more information.</p>
          </div> :
      <div/>
      }
    </div>
  );
};
